(function ($, window, document) {
  $(document).ready(function () {
    // Initialize Lenis for smooth scrolling
    const lenis = new Lenis({
      duration: 1.5, // Reduce the duration to make the scroll smoother
      easing: (t) => 1 - Math.pow(1 - t, 3), // Change easing to a smoother easeOutCubic function
      smoothWheel: true,
      smoothTouch: true,
      touchMultiplier: 1.5, // Increase the multiplier for touch devices to make scrolling easier
      wheelMultiplier: 1.2, // Increase the multiplier for mouse wheel to make scrolling easier
      infinite: false,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    if (window.innerWidth >= 995) {
      lenis.on("scroll", () => {
        $('body').hasClass("popup-active") ? lenis.stop() : lenis.start(); //to stop/start lenis scroll
        ScrollTrigger.update();
      });
    }

    $(document).click(function (event) {
      if ($(event.target).hasClass('accreditation-anchor-image') || $(event.target).hasClass('fancybox-image') || $(event.target).hasClass('wistia-video-embeded')) { //on image click stop lenis scroll
        lenis.stop();
      } else {
        lenis.start();
      }
    });

    $('a').each(function() {
      let href = $(this).attr('href');
      let target = $(this).attr('target');
      
      // Skip if link has target="_blank"
      if (target === '_blank') {
        return true; // continue to next iteration
      }
      
      // Check if the link includes a hash (and is not just a hash)
      if (href && href.includes('#') && href.length > 1) {
        let headerHeight = $('header').outerHeight(true),
          staticSecondaryMenuHeight = ($('.static-secondary-menu').length && $(window).width() > 768) ? 50 : 0,
          wpAdminBar = $('#wpadminbar').length ? $('#wpadminbar').outerHeight(true) : 0;

        $(this).click(function(event) {
          // Prevent default behavior
          event.preventDefault();
          
          // Extract the target section ID
          let targetID = href.split('#')[1]; // Get the ID part after the hash
          let target = $('#' + targetID); // Select the target element
          
          if (target.length) {
            let targetMarginTop = parseInt(target.css('margin-top'));
            let clickedElement = $(this); 
            // If the target exists on the current page, scroll to it

            if ((clickedElement.parents('.child-dropdown-active').length || $('.child-page-dropdown > .child-dropdown-active').length) && window.innerWidth < 767) {
              clickedElement.parents('.child-dropdown-active ul').slideUp();
              $('.child-page-dropdown > ul').slideUp();
              clickedElement.parents('.child-dropdown-active').removeClass('child-dropdown-active');
              $('.child-page-dropdown .dropdown-active-page').removeClass('child-dropdown-active');
            }
            
            lenis.stop();
            $('html, body').animate({
              scrollTop: target.offset().top - headerHeight - wpAdminBar - targetMarginTop + staticSecondaryMenuHeight
            }, 650, null, function() {
              lenis.start();
            });
          } else {
            // If the target doesn't exist on the current page, perform a regular navigation
            window.location.href = href; // Change the page
          }
        });
      }
    });

    // Initialize Fancybox
    if ($('a[data-fancybox]').length) {
      $('.accreditation-anchor-image').parents('ul').each(function (index, element) {
        let currentContainer = $(this);
        currentContainer.find('a[data-fancybox]').each(function () {
          let currentFancybox = $(this);
          currentFancybox.attr('data-fancybox', 'gallery-' + index);
        })
      });
      
      $('.accreditation-anchor-image').click(function () {
        let currentClicked = $(this),
          elementparent = currentClicked.parents('ul');

          fancyBoxOpen(elementparent.find('a[data-fancybox]'));
      })
      
      fancyBoxOpen($('a[data-fancybox]'));
    }


    function fancyBoxOpen(selector) {
      selector.fancybox({
        buttons: [
          'slideShow',
          'zoom',
          'thumbs',
          "download",
          'close'
        ],
        touch: {
          vertical: false, // Disable vertical drag/swipe gesture
        },
        loop: false,
        protect: true,
        afterShow: function (instance, current) {
          // Assuming you have a button with the class 'modal-button' inside your Fancybox content
          $('.fancybox-button--close').on('click', function () {
            lenis.start();
          });
        }
      });
    }

    //to scroll to particular section for video page
    $(document).on("click", ".video-menu", function (e) {
      e.preventDefault();
      let adminBar = $('#wpadminbar').length ? $('#wpadminbar').outerHeight() : 0,
        targetId = $(this).parent().attr('data-section-id'),
        targetOffSet = ($('header').outerHeight() + $('.place-holder-menu').outerHeight() + adminBar),
        targetPosition = $(targetId).offset().top - targetOffSet;

      // Use Lenis to smoothly scroll to the target position
      lenis.scrollTo(targetPosition, {
        duration: 1, // Duration in seconds (300ms)
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)) // easeOutQuad easing function
      });
    });

    $(window).on('load resize', function () {
      let scrollableInteraction = false;
      ['click', 'scroll', 'mousemove', 'mousewheel', 'touchstart'].forEach(function(e) {
        document.addEventListener(e, firstInteraction, {
          once: true
        });
      });


      function firstInteraction() {
        if (!scrollableInteraction) {
          scrollableInteraction = true;
          
          // for accessibe ScreenReader overflow issue fix
          setTimeout(() => {
            const accessibeGeneratedElement = $('access-widget-ui');
            let weAccessibeVisible = true;
            if (accessibeGeneratedElement.length) {
              let accessibeScreenReader = $('access-widget-ui')[0].shadowRoot;
              let accessibeScreenReaderButton = accessibeScreenReader.querySelector('button.screen-reader-button'); // Replace with your actual selector
  
              if ($(accessibeScreenReaderButton).length) {
                $(accessibeScreenReaderButton).css('display', 'none');
              }
              weAccessibeVisible = false;
            }
          }, 1500);
  
          if (window.innerWidth >= 995) {
            let debounceTimer;
            let slateObserverFlag = true;
  
            $(document).on('keyup', 'input[role="combobox"]', function () {
              clearTimeout(debounceTimer); // Clear any previous timer
  
              debounceTimer = setTimeout(() => {
                const slateScrollableSectionClass = 'suggest'; 
                const $sections = $(`.${slateScrollableSectionClass}`);
  
                if ($sections.length) { 
                  $sections.each(function () {
                    const $section = $(this);
                    fixScrollDisable($section); // Call the fixScrollDisable method
                  });
                }
  
                if (slateObserverFlag) {
                  // Create an observer instance
                  const observer = new MutationObserver((mutationsList, observer) => {
                    for (const mutation of mutationsList) {
                      // Check if nodes were added
                      if (mutation.type === 'childList' && mutation.addedNodes.length) {
                        // Call our function to handle the shadow DOM
                        const $sections = $('.dialog_host .content');
                        if ($sections.length) { 
                          $sections.each(function () {
                            const $section = $(this);
                            fixScrollDisable($section); // Call the fixScrollDisable method
                          });
                        }
                      }
                    }
                  });
  
                  // Start observing the document body for child nodes being added
                  observer.observe(document.body, { childList: true, subtree: true });
                  // Initial check to see if the shadow DOM already exists
                }
  
              }, 500); // Adjust the timeout duration as needed (300 ms in this case)
            });
  
            // Array of classes for internal scrollable sections
            const scrollableSectionClasses = ['scrollable-section', 'wptb-table-container', 'wp-block-table', 'suggest'];
  
            // Use jQuery to loop through the classes and apply event listeners
            $.each(scrollableSectionClasses, function (index, className) {
              $(`.${className}`).each(function () {
                const $section = $(this);
                fixScrollDisable($section);
              });
            });
  
            // for accessibe dialog box scroll fix
            setTimeout(() => {
              const accessibeElement = $('access-widget-ui');
              let observerFlag = true;
              if (accessibeElement.length) {
                $(accessibeElement).each(function () {
                  const shadowElement = $(this).get(0).shadowRoot;
                  const accessibeElementTrigger = shadowElement.querySelector('button[part="acsb-trigger"]'); // Replace with your actual selector
          
                  if (accessibeElementTrigger) {
                    // Function to check and handle the shadow DOM
                    function handleShadowDOM() {
                      let shadowElement = $('access-widget-ui[data-acsb="widget"]').get(0);
                      
                      if (shadowElement && shadowElement.shadowRoot) {
                        const insideWidgetElement = shadowElement.shadowRoot.querySelector('.widget-container__trap .main'); // Replace with your actual selector
                        const languageWidgetElement = shadowElement.shadowRoot.querySelector('.base-modal'); // Replace with your actual selector
                        fixScrollDisable($(insideWidgetElement));
                        fixScrollDisable($(languageWidgetElement));
                      }
                    }
  
                    if (observerFlag) {
                      // Create an observer instance
                      const observer = new MutationObserver((mutationsList, observer) => {
                        for (const mutation of mutationsList) {
                          // Check if nodes were added
                          if (mutation.type === 'childList' && mutation.addedNodes.length) {
                            // Call our function to handle the shadow DOM
                            handleShadowDOM();
                          }
                        }
                      });
  
                      // Start observing the document body for child nodes being added
                      observer.observe(document.body, { childList: true, subtree: true });
                      // Initial check to see if the shadow DOM already exists
                      handleShadowDOM();
                    }
  
                    $(accessibeElementTrigger).click(function () {
                      let shadow = $('access-widget-ui[data-acsb="widget"]').get(0).shadowRoot;
                      
                      if (shadow) {
                        const insideShadowElement = shadow.querySelector('.widget-container__trap .main'); // Replace with your actual selector
                        const languageShadowElement = shadow.querySelector('.base-modal'); // Replace with your actual selector
                        fixScrollDisable($(insideShadowElement));
                        fixScrollDisable($(languageShadowElement));
                      }
                    });
                  }
                });
                observerFlag = false;
              }
            }, 1500);
              
            function fixScrollDisable(section) {
              section.on('mouseenter', function () {
                lenis.stop(); // Stop Lenis when entering a scrollable section with a scrollbar
              }).on('mouseleave', function () {
                lenis.start(); // Start Lenis when leaving a scrollable section
              }).on('wheel', function (event) {
                event.stopPropagation(); // Prevent the wheel event from propagating to Lenis if scrollbar is present
              });
            }
          }
        }
      }
    });
  });

})(jQuery, window, document);
